import React from 'react';
import CampaignList from "../components/CampaignList";
import MainLayout from '../pages/MainLayout'; // Adjust the path if needed


export default function Campaign() {
  return (
    <MainLayout>
      <CampaignList />
    </MainLayout>
  );
}
